import React, { useState } from "react";
import { Form, Button, InputGroup, Modal } from "react-bootstrap";
import {
  addNewFAQsCategory,
  deleteFAQsCategoriesById,
  fetchFAQsCategories,
  updateFAQsCategory,
} from "../../services/axios/apiManager";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { handleErrors } from "../../services/dataManager";
const FaqCategories = ({
  faqCategories,
  setFaqCategories,
  catsPermsgranted,
  getData,
}) => {
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState("");
  const [showPromptModal, setShowPromptModal] = useState(false);
  const [promptOptions, setPromptOptions] = useState({});
  const [titleError, setTitleError] = useState("");
  const [faqCategory, setFaqCategory] = useState({
    id: "",
    title: "",
    status: 1,
  });

  const handleSelectCategory = async (e) => {
    e.preventDefault();
    const id = e.target.value;
    setSelectedCategory(id);
    if (id) {
      const category = faqCategories.find((f) => f.id == id);
      setFaqCategory(category);
    } else {
      setFaqCategory({
        id: "",
        title: "",
        status: 0,
      });
    }
  };
  // // // Add A New Category
  const handleAddCategory = async () => {
    if (!catsPermsgranted.some((perm) => perm.type === "create")) {
      toast.error(
        "You don't have neccessary permissions to do this operation!",
        {
          duration: 3000,
        },
      );
      return;
    }
    const validated = validateTitle();

    if (validated && faqCategory?.title?.length > 0) {
      const data = { title: faqCategory.title, status: faqCategory.status };
      const res = await addNewFAQsCategory(data);

      if (res?.data?.success) {
        await getData();
        toast.success("Category has been added!", { duration: 2000 });
        setPromptOptions({});
        setShowPromptModal(false);
        setSelectedCategory("");
        setFaqCategory({
          id: "",
          title: "",
          status: 1,
        });
      } else {
        handleErrors(res, navigate, "Add Category:");
      }
    }
  };

  // // // Update Category
  const handleUpdateCategory = async () => {
    if (!catsPermsgranted.some((perm) => perm.type === "update")) {
      toast.error(
        "You don't have neccessary permissions to do this operation!",
        {
          duration: 3000,
        },
      );
      return;
    }
    const validated = validateTitle();
    if (validated && faqCategory?.id) {
      const res = await updateFAQsCategory(faqCategory);
      if (res?.data?.success) {
        await getData();
        toast.success("Category has been updated!", { duration: 2000 });
        setPromptOptions({});
        setShowPromptModal(false);
        setSelectedCategory("");
        setFaqCategory({
          id: "",
          title: "",
          status: 1,
        });
      } else {
        handleErrors(res, navigate, "Update Category:");
      }
    }
  };

  const handleCloseOptionsModal = () => {
    setPromptOptions({});
    setShowPromptModal(false);
  };
  // // // Delete Logic

  const handleDeleteCategory = () => {
    if (!catsPermsgranted.some((perm) => perm.type === "delete")) {
      toast.error(
        "You don't have neccessary permissions to do this operation!",
        {
          duration: 3000,
        },
      );
      return;
    }
    if (faqCategory?.id) {
      setPromptOptions({
        header: "Delete FAQ Category",
        body: `Are you sure you want to delete "${faqCategory?.title || ""}"?`,
        okay: "Delete",
        method: deleteCategory,
        data: { id: faqCategory.id },
      });
      setShowPromptModal(true);
    }
  };

  const deleteCategory = async () => {
    if (faqCategory?.id) {
      const res = await deleteFAQsCategoriesById(faqCategory?.id);
      if (res?.data?.success && res?.data?.data === 1) {
        const categoriesResponse = await fetchFAQsCategories();
        if (categoriesResponse?.data?.data) {
          setFaqCategories(categoriesResponse.data.data);
        }
        toast.success("Category has been deleted!", { duration: 2000 });
        setPromptOptions({});
        setSelectedCategory("");
        setShowPromptModal(false);
        setFaqCategory({
          id: "",
          title: "",
          status: 1,
        });
      } else {
        handleErrors(res, navigate, "Delete Category:");
      }
    }
  };

  const validateTitle = () => {
    if (!faqCategory.title.trim()) {
      setTitleError("Title is required");
      return false;
    } else {
      setTitleError("");
      return true;
    }
  };
  const handleClearForm = () => {
    setSelectedCategory("");
    setFaqCategory({
      id: "",
      title: "",
      status: 1,
    });
  };

  return (
    <div className="container bg-dark mb-4 rounded">
      <div className="row mb-3">
        <div className="bg-dark mt-4 rounded mb-4">
          <h3 className="text-light">FAQ's Categories</h3>
          <div className="row">
            <div className="col-lg-4">
              <InputGroup className="mb-3">
                <Form.Select
                  type="text"
                  placeholder="Search FAQs by category..."
                  value={selectedCategory}
                  onChange={(e) => {
                    handleSelectCategory(e);
                  }}
                  className="bg-dark text-light border-light input-placeholder-light"
                >
                  <option value="">Select a category</option>
                  {faqCategories?.map((c) => (
                    <option
                      value={c.id}
                    >{`${c.title} - ${c.status === 1 ? "active" : "Inactive"}`}</option>
                  ))}
                </Form.Select>
              </InputGroup>
            </div>
            <div className="col-lg-2">
              <Button
                className="ml-1"
                variant="success"
                title="clear form"
                onClick={() => {
                  handleClearForm();
                }}
              >
                Clear Form
              </Button>
            </div>
          </div>
          <Form>
            <div className="row">
              <div className="col-lg-6">
                <Form.Group className="mb-3">
                  <Form.Label>Title</Form.Label>
                  <Form.Control
                    type="text"
                    required
                    placeholder="Enter Category name"
                    value={faqCategory?.title || ""}
                    onChange={(e) => {
                      setFaqCategory((prev) => ({
                        ...prev,
                        title: e.target.value,
                      }));
                      validateTitle();
                    }}
                    onBlur={validateTitle}
                    className="bg-dark text-light border-light"
                  />
                  {titleError && (
                    <span className="text-danger">{titleError}</span>
                  )}
                </Form.Group>
              </div>
              <div className="col-lg-6">
                <Form.Group className="mb-3">
                  <Form.Label>Status</Form.Label>
                  <Form.Select
                    value={faqCategory?.status | 0}
                    onChange={(e) => {
                      setFaqCategory((prev) => ({
                        ...prev,
                        status: e.target.value,
                      }));
                    }}
                    className="bg-dark border-light text-light"
                  >
                    <option value="1">Active</option>
                    <option value="0">Inactive</option>
                  </Form.Select>
                </Form.Group>
              </div>
            </div>
            <div class="container-fluid">
              <div class="d-flex justify-content-end">
                {faqCategory?.id ? (
                  <div>
                    {!faqCategory?.is_associated && (
                      <Button
                        className="ml-3"
                        variant="danger"
                        onClick={handleDeleteCategory}
                      >
                        Delete Category
                      </Button>
                    )}
                    <Button
                      className="ml-3"
                      variant="success"
                      title="update category"
                      onClick={handleUpdateCategory}
                    >
                      Update Category
                    </Button>
                  </div>
                ) : (
                  <Button
                    className="ml-3"
                    variant="success"
                    title="Add new category"
                    onClick={handleAddCategory}
                  >
                    Add Category
                  </Button>
                )}
              </div>
            </div>
          </Form>
          <Modal
            show={showPromptModal}
            onHide={handleCloseOptionsModal}
            centered
            className="text-light"
          >
            <Modal.Header closeButton className="bg-dark text-light border-0">
              <Modal.Title>{promptOptions.header}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="bg-dark text-light">
              {promptOptions.body}
            </Modal.Body>
            <Modal.Footer className="bg-dark text-light border-0">
              <Button variant="secondary" onClick={handleCloseOptionsModal}>
                Cancel
              </Button>
              <Button
                variant="danger"
                onClick={() => {
                  promptOptions.method();
                }}
              >
                {promptOptions.okay}
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </div>
  );
};
export default FaqCategories;
